"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragIcon = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var DragLabel = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement("div", { className: "drag-label center", ref: props.divRef },
        react_1.default.createElement(exports.DragIcon, null),
        !!props.text && react_1.default.createElement("div", { className: "drag-label__text" }, props.text)));
});
var DragIcon = function () {
    return (react_1.default.createElement("div", { className: "drag-icon" },
        react_1.default.createElement("div", { className: "drag-icon__top-piece" }),
        react_1.default.createElement("div", { className: "drag-icon__bottom-piece" })));
};
exports.DragIcon = DragIcon;
exports.default = DragLabel;
